module.exports = __webpack_public_path__ + "img/filter.99cb3ea0.svg";